import React from 'react';
import { usePublicList } from '../hooks/usePublicList';
import { buildImageUrl } from '../api/client';

export default function Projects() {
  const { data: projects, loading } = usePublicList('projects');
  const sorted = [...projects].sort((a, b) => a.order - b.order);
  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title">Layihələr</h2>
        <p className="section-subtitle">Həyata keçirdiyimiz layihələr</p>
        {loading ? <p style={{ textAlign: 'center', color: '#6b7280' }}>Yüklənir...</p> : (
          <div className="grid-3">
            {sorted.map((p) => (
              <div key={p.id} className="pcard">
                <div className="thumb"><img src={buildImageUrl(p.image)} alt={p.title} /></div>
                <h5>{p.title}</h5>
                <p>{p.address}<br/>{p.street}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
